import imRequest from '../imRequest';
import { IM_API } from '../../constants/endpoints';

export const pickerApi = {
  stickers: (q) =>
    imRequest.get(`${IM_API}/picker/stickers`, { params: q ? { q } : undefined }),

  gifs: (q) =>
    imRequest.get(`${IM_API}/picker/gifs`, { params: q ? { q } : undefined }),

  reactions: (q) =>
    imRequest.get(`${IM_API}/picker/reactions`, { params: q ? { q } : undefined }),
};

export const memberSummaryApi = {
  /** @param {Array<number|string>} ids */
  batch: (ids) => {
    const list = (ids || []).filter((id) => id != null && id !== '');
    if (!list.length) {
      return Promise.resolve([]);
    }
    return imRequest.get(`${IM_API}/members/summaries`, {
      params: { ids: list.join(',') },
    });
  },
};

export const mediaApi = {
  resolveByMessage: (conversationId, serverMessageId) =>
    imRequest.get(
      `${IM_API}/conversations/${conversationId}/messages/${serverMessageId}/media`
    ),

  resolveObjectKey: (conversationId, objectKey) =>
    imRequest.get(`${IM_API}/conversations/${conversationId}/media/resolve`, {
      params: { objectKey },
    }),
};
